import React from "react";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ color }: { color?: string }) => {
  const strokeColor = color ? color : "#9A9A9A";

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="chevron/down">
        <path
          id="Icon"
          d="M18 10L12.7071 15.2929C12.3166 15.6834 11.6834 15.6834 11.2929 15.2929L6 10"
          stroke={strokeColor}
          strokeWidth="1.67"
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
};
